// extracted by mini-css-extract-plugin
export default {"card":"MuseumCard_card__ESZ59","mainImage":"MuseumCard_mainImage__wrzNx","otherImages":"MuseumCard_otherImages__UGOkB","title":"MuseumCard_title__8Y3xP"};